import { useLayoutEffect, useMemo, useState } from "react";
import type { UseSidebarSearchArgs, UseSidebarSearchResult } from "./types";

export const useSidebarSearch = ({
  sortedItems,
  sidebarMode,
  isCollapsed,
}: UseSidebarSearchArgs): UseSidebarSearchResult => {
  const [normalizedSearchQuery, setNormalizedSearchQuery] = useState("");

  const isSearching = normalizedSearchQuery !== "";

  const searchedItems = useMemo(
    () =>
      isSearching
        ? sortedItems.filter((item) =>
            item.label.toLowerCase().includes(normalizedSearchQuery),
          )
        : sortedItems,
    [sortedItems, isSearching, normalizedSearchQuery],
  );

  // Layout effect: no frame paints the new tab filtered by the old query
  useLayoutEffect(() => {
    setNormalizedSearchQuery("");
  }, [sidebarMode, isCollapsed]);

  return {
    normalizedSearchQuery,
    isSearching,
    searchedItems,
    setNormalizedSearchQuery,
  };
};
